import { Attribute, AttributeProperty, ContainerAttributes } from "react-builder";

export class CarouselItemStateAttributes extends Attribute {
  @AttributeProperty({ title: "Carousel Item Container", type: "Object", cssTarget: "" })
  itemContainer: ContainerAttributes = new ContainerAttributes();
  @AttributeProperty({ type: "String", cssProperty: "cursor", cssTarget: "" })
  Cursor?: string;
}
